import React from "react";
import "../../Stylesheets/CustomButtonsStyles.css";

const CustomLoader = (props) => {
  return (
    <>
      <div className="LoadingContainerMain">
        <div className="LoadingContainer">
          <h4 className="LoadingText">{props.loadingTitle}</h4>
          <div className="dots">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomLoader;
